module.exports = __webpack_public_path__ + "img/BeccaPalette4.95d64c75.jpg";